var _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevopsSpinner2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    id: "svg31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#272627",
    opacity: 1,
    "data-original": "#000000",
    className: "",
    id: "path2"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)",
    id: "g27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255 32.758 12.497 45.255 0S12.497 12.497 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#272627",
      strokeOpacity: 1
    },
    transform: "translate(444.576 415.32)",
    fill: "#ffffff",
    "data-original": "#f5737f",
    className: "",
    opacity: 1,
    id: "path7"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "18.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1
    },
    x: -31.624678,
    y: -600.75989,
    id: "text2310-9",
    transform: "matrix(0.70710678,-0.70710678,-0.70710678,-0.70710678,0,0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2308-4",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "18.6667px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Heavy'",
      strokeWidth: 1
    },
    x: -31.624678,
    y: -600.75989
  }, "PMP")), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255 32.758 12.497 45.255 0S12.497 12.497 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#272627",
      strokeOpacity: 1
    },
    transform: "translate(112.68 51.424)",
    fill: "#ffffff",
    "data-original": "#d8ec84",
    className: "",
    opacity: 1,
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255 32.758 12.497 45.255 0S12.497 12.497 0 0Z",
    style: {
      strokeWidth: 2.00000598,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    transform: "translate(444.576 415.32)",
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255 32.758 12.497 45.255 0S12.497 12.497 0 0Z",
    style: {
      strokeWidth: 2.00000598,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    transform: "translate(112.68 51.424)",
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a247.164 247.164 0 0 1 48.513-4.783c135.862 0 246 110.138 246 246 0 59.309-20.992 113.713-55.947 156.196",
    style: {
      strokeWidth: 2.00000598,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    transform: "translate(207.487 14.783)",
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a247.138 247.138 0 0 1-48.98 4.877c-135.862 0-246-110.138-246-246 0-59.309 20.992-113.713 55.947-156.196",
    style: {
      strokeWidth: 2.00000598,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path17",
    transform: "translate(304.98 497.123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.864209,94.361542 H 109.86432 V 54.361422 H 69.864209 Z",
    fill: "none",
    id: "path2-5",
    style: {
      strokeWidth: 1.66667
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    transform: "translate(348.078 484.185)",
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "#272627"
    },
    transform: "translate(164.358 27.639)",
    fill: "none",
    stroke: "#272627",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1,
    id: "path25"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "18.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1
    },
    x: -31.252792,
    y: 123.01755,
    id: "text2310",
    transform: "matrix(-0.70710678,0.70710678,0.70710678,0.70710678,0,0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2308",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "18.6667px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Heavy'",
      strokeWidth: 1
    },
    x: -31.252792,
    y: 123.01755
  }, "PMO")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "40.0001px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1
    },
    x: 416.57983,
    y: -435.80658,
    id: "text11550",
    transform: "scale(1,-1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan11548",
    style: {
      strokeWidth: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevopsSpinner2);
export default __webpack_public_path__ + "static/media/devops-spinner2.b7a7f580dc940770c8df3bfe9097973c.svg";
export { ForwardRef as ReactComponent };